import { render, staticRenderFns } from "./UserCardList.vue?vue&type=template&id=8f2bcfdc"
import script from "./UserCardList.vue?vue&type=script&lang=js"
export * from "./UserCardList.vue?vue&type=script&lang=js"
import style0 from "./UserCardList.vue?vue&type=style&index=0&id=8f2bcfdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports